module.exports = __webpack_public_path__ + "media/images/countryrect/tv-89152d828ada70c512eca4747a41acd8.svg";